var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVectorTopLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 539,
    viewBox: "0 0 208 539",
    width: 208,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-519.022 442.47c-73.589-101.286-51.136-243.049 50.15-316.638 101.286-73.5879 228.986-148.2904 318.551-231.44 89.5637-83.15 255.338-60.014 316.637 50.1505 61.3 110.1651 62.8 234.5745-50.15 316.6375-112.95053 82.063-207.5629 150.803-318.551 231.441-110.988 80.637-243.049 51.135-316.637-50.151z",
    fill: "#cbe4ce",
    opacity: 0.2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVectorTopLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vectorTopLeft.5ca51e4d33c4d5e13265f8cccb37c6ed.svg";